module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/scandal.498a1de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/scandal.jpg
// module id = ieFf
// module chunks = 0